import {
  ACTIVITY_SUMMARY_CONTACTS,
  ACTIVITY_SUMMARY_LOADING,
  CLEAR_ACTIVITY_SUMMARY_CONTACTS,
  GET_PAS_DUE_TASKS_COUNT,
  GET_SUMMARY_ACCOUNTS,
  GET_SUMMARY_CALLS,
  GET_SUMMARY_CALL_TIME,
  GET_SUMMARY_DEMOS,
  GET_SUMMARY_EMAILS,
  GET_SUMMARY_GIVE_UPS,
  GET_SUMMARY_INCOMING_CALLS,
  GET_SUMMARY_INCOMING_CALL_TIME,
  GET_SUMMARY_LONG_CALLS,
  GET_SUMMARY_MEETINGS,
  GET_SUMMARY_PROSPECTS,
  GET_SUMMARY_REFERRALS,
  RESET_ACTIVITY_SUMMARY,
} from './types'

const initState = {
  calls: {},
  callTime: {},
  longCalls: {},
  incomingCalls: {},
  incomingCallTime: {},
  emails: {},
  demos: {},
  meetings: {},
  prospects: {},
  accounts: {},
  referrals: {},
  giveUps: {},
  contactsData: {},
  pasDueTasksCount: null,
  isLoading: false,
}

const ActivitySummaryReducer = (state = initState, action) => {
  switch (action.type) {
    case ACTIVITY_SUMMARY_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case GET_PAS_DUE_TASKS_COUNT:
      return {
        ...state,
        pasDueTasksCount: action.payload,
      }
    case GET_SUMMARY_CALLS:
      return {
        ...state,
        calls: action.payload,
      }
    case GET_SUMMARY_CALL_TIME:
      return {
        ...state,
        callTime: action.payload,
      }
    case GET_SUMMARY_INCOMING_CALLS:
      return {
        ...state,
        incomingCalls: action.payload,
      }
    case GET_SUMMARY_INCOMING_CALL_TIME:
      return {
        ...state,
        incomingCallTime: action.payload,
      }
    case GET_SUMMARY_EMAILS:
      return {
        ...state,
        emails: action.payload,
      }
    case GET_SUMMARY_DEMOS:
      return {
        ...state,
        demos: action.payload,
      }
    case GET_SUMMARY_MEETINGS:
      return {
        ...state,
        meetings: action.payload,
      }
    case GET_SUMMARY_PROSPECTS:
      return {
        ...state,
        prospects: action.payload,
      }
    case GET_SUMMARY_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
      }
    case GET_SUMMARY_REFERRALS:
      return {
        ...state,
        referrals: action.payload,
      }
    case GET_SUMMARY_GIVE_UPS:
      return {
        ...state,
        giveUps: action.payload,
      }
    case GET_SUMMARY_LONG_CALLS:
      return {
        ...state,
        longCalls: action.payload,
      }
    case RESET_ACTIVITY_SUMMARY: {
      return {
        ...state,
        data: {},
      }
    }
    case ACTIVITY_SUMMARY_CONTACTS: {
      return {
        ...state,
        contactsData: action.payload,
      }
    }
    case CLEAR_ACTIVITY_SUMMARY_CONTACTS:
      return {
        ...state,
        contactsData: {},
      }
    default:
      return state
  }
}

export default ActivitySummaryReducer
